import React from 'react';
import { FiX, FiCalendar, FiTag, FiUser, FiFilter, FiCheck } from 'react-icons/fi';
import '../styles/FilterPanel.css';

interface FilterPanelProps {
  filters: {
    status: string;
    assignedTo: string;
    dateRange: {
      from: string;
      to: string;
    }
  };
  updateFilter: (field: string, value: any) => void;
  updateDateRange: (field: 'from' | 'to', value: string) => void;
  clearFilters: () => void;
  onClose: () => void;
  isOpen: boolean;
}

const FilterPanel: React.FC<FilterPanelProps> = ({
  filters,
  updateFilter,
  updateDateRange,
  clearFilters,
  onClose,
  isOpen
}) => {
  return (
    <div className={`filter-sidebar ${isOpen ? 'open' : ''}`}>
      <div className="filter-sidebar-header">
        <h3><FiFilter /> Filters</h3>
        <button className="close-button" onClick={onClose}>
          <FiX />
        </button>
      </div>

      <div className="filter-sidebar-content">
        <div className="filter-group">
          <label htmlFor="filter-status">
            <FiTag /> Status
          </label>
          <select
            id="filter-status"
            value={filters.status}
            onChange={(e) => updateFilter('status', e.target.value)}
          >
            <option value="">All status</option>
            <option value="Novo">New</option>
            <option value="Contato Inicial">Initial Contact</option>
            <option value="Qualificado">Qualified</option>
            <option value="Proposta">Proposal</option>
            <option value="Negociação">Negotiation</option>
            <option value="Fechado">Closed</option>
            <option value="Perdido">Lost</option>
          </select>
        </div>

        <div className="filter-group">
          <label htmlFor="filter-assignee">
            <FiUser /> Assigned To
          </label>
          <input
            id="filter-assignee"
            type="text"
            placeholder="Assignee name"
            value={filters.assignedTo}
            onChange={(e) => updateFilter('assignedTo', e.target.value)}
          />
        </div>

        <div className="filter-group date-range">
          <label>
            <FiCalendar /> Creation Period
          </label>
          <div className="date-inputs">
            <div className="date-input">
              <label htmlFor="filter-date-from">From</label>
              <input
                id="filter-date-from"
                type="date"
                value={filters.dateRange.from}
                onChange={(e) => updateDateRange('from', e.target.value)}
              />
            </div>
            <div className="date-input">
              <label htmlFor="filter-date-to">To</label>
              <input
                id="filter-date-to"
                type="date"
                value={filters.dateRange.to}
                onChange={(e) => updateDateRange('to', e.target.value)}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="filter-sidebar-footer">
        <button className="filter-button secondary" onClick={clearFilters}>
          Clear filters
        </button>
        <button className="filter-button primary" onClick={onClose}>
          <FiCheck /> Apply filters
        </button>
      </div>
    </div>
  );
};

export default FilterPanel; 